.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 400px;
    gap: var(--exo-spacing-x-small);
    text-align: center;
}

.code {
    margin: var(--exo-spacing-2x-small) 0 0;
}

.message {
    font-size: var(--exo-font-size-small);
    margin: 0 0 var(--exo-spacing-small);
}
